function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.date.to-json.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url.to-json.js";
import "core-js/modules/web.url-search-params.js";
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { hitEventTms } from 'integration-web-core--socle/js/assets/commons/_tms';
import ContentLoader from 'integration-web-core--socle/js/assets/modules/_contentLoader';
import Utils from '../utils/Utils';
function $encoding() {
  var input = document.querySelector('.js-select-wrapper__input');
  var loader = document.querySelector('span.js-content-loader:last-child');
  if (loader && input && input.options[input.selectedIndex].value.length) {
    var srcContent = loader.dataset.srcContent;
    var _srcContent$split = srcContent.split('&filter='),
      _srcContent$split2 = _slicedToArray(_srcContent$split, 2),
      url = _srcContent$split2[0],
      univers = _srcContent$split2[1];
    loader.dataset.srcContent = "".concat(url, "&filter=").concat(encodeURIComponent(univers));
  }
}
function $callback() {
  var showMore = document.querySelector('.js-show-more');
  var content = document.querySelector('.js-content-loader.lazy-loaded');
  $encoding();
  Utils.debounce(lm.lazyload.observe, 0);

  // Remove last content loader informations element
  if (content && !showMore) content.remove();

  // Remove Button after first call
  if (showMore) showMore.remove();

  // Init filter param
  var url = new URL(document.location);
  var filterParam = url.searchParams.get("filter");

  // Increment pagination and update url on hot-reload
  if (currentPage < maxPage) {
    currentPage++;
    if (filterParam) {
      window.history.replaceState("", "", "?p=" + currentPage + "&filter=" + url.search.slice(url.search.indexOf("filter=") + "filter=".length));
    } else {
      window.history.replaceState("", "", "?p=" + currentPage);
    }
  }
}

/**
 * @param {String} trackingInfo
 */
function $contentDispatcher(trackingInfo) {
  // First action, click on see more
  document.querySelector('.js-content-loader').addEventListener('click', function (e) {
    e.preventDefault();
    new ContentLoader(e.target, $callback);
    var tagCo = {
      categories: 'Lazyload - Clic',
      action: trackingInfo,
      label: window.location.href
    };
    hitEventTms(e.target, 'gaEvent', JSON.stringify(tagCo));
  });

  // Event sent by lazyload.js
  document.addEventListener('contentLoading', function () {
    Utils.debounce(function () {
      var lastContentLoader = document.querySelector('span.js-content-loader:last-child');
      if (lastContentLoader) {
        new ContentLoader(lastContentLoader, $callback);
        var tagCo = {
          categories: 'Lazyload - Scroll',
          action: trackingInfo,
          label: window.location.href
        };
        hitEventTms(document, 'gaEvent', JSON.stringify(tagCo));
      }
    }, 100);
  });
}
var ContentHandler = /*#__PURE__*/_createClass(
/**
 * @constructor
 * @param {String} trackingInfo
 */
function ContentHandler(trackingInfo) {
  _classCallCheck(this, ContentHandler);
  if (document.querySelector('.js-content-loader')) {
    $contentDispatcher(trackingInfo);
  }
});
export { ContentHandler as default };